var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.InputTextLines),function(part){return _c('p',{key:part},[_vm._v(" "+_vm._s(part)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }